// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DrSu","buttons":"styles_buttons__HoKhp"};